import { render, staticRenderFns } from "./CustomerTiaoJieGongNengSub.vue?vue&type=template&id=36608242&"
import script from "./CustomerTiaoJieGongNengSub.vue?vue&type=script&lang=js&"
export * from "./CustomerTiaoJieGongNengSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports